var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Prop, Component, Watch } from "vue-property-decorator";
import TemplateBase from "./TemplateBase";
import NavRow from "@/common/components/NavRow.vue";
import HeaderRow from '@/common/components/HeaderRow.vue';
import { ValidationObserver } from 'vee-validate';
import ValidationErrors from '@/common/components/ValidationErrors.vue';
import InstructionLink from "@/template/components/shared/InstructionLink.vue";
import PrintPdf from '@/common/components/buttons/PrintPdf.vue';
import FormStatus from '@/common/components/FormStatus.vue';
var RecordableView = /** @class */ (function (_super) {
    __extends(RecordableView, _super);
    function RecordableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deadline = null;
        return _this;
    }
    Object.defineProperty(RecordableView.prototype, "type", {
        get: function () {
            return this.recordableType;
        },
        enumerable: false,
        configurable: true
    });
    RecordableView.prototype.created = function () {
        this.recordId = this.$route.params.id;
        this.addDirtySubscription();
    };
    RecordableView.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RecordableView.prototype.beforeDestroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.unlockSection()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.$store.dispatch("vuexPageModule/clean")];
                    case 2:
                        _a.sent();
                        this.disableDirtySubscription();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Runs after section has been switched
     */
    RecordableView.prototype.onRouteChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.unlockSection()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.$store.dispatch("vuexPageModule/cleanSectionState")];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.init()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RecordableView.prototype, "isRecordLoaded", {
        /**
         * Returns true once the record entity exists (ie. has been loaded).
         */
        get: function () {
            return !!this.recordable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "preventSending", {
        get: function () {
            return this.$store.getters["vuexPageModule/preventSending"];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "preventSendingMessage", {
        get: function () {
            return this.$store.getters["vuexPageModule/preventSendingMessage"];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "title", {
        /**
         * View title.
         */
        get: function () {
            var key = this.titleKey(this.recordable);
            return this.$t(key).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "tabTitle", {
        get: function () {
            return this.$t(this.$route.meta.title).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "isSinglePageForm", {
        get: function () {
            return !this.multipleSections;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "specifier", {
        /**
         * Optional specifier.
         * For aid applications this is the localised aid type.
         */
        get: function () {
            if (this.specifierKey) {
                var key = this.specifierKey(this.recordable);
                return ": " + this.$t(key).toString();
            }
            else {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "aidTargetNumber", {
        get: function () {
            var aidTargetNumber = null;
            if (this.recordable && this.recordable.record) {
                aidTargetNumber = this.recordable.record.aidTargetNumber;
            }
            return aidTargetNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "tabProps", {
        /**
         * Returns the resolved properties for the currently visible tab.
         */
        get: function () {
            return this.$route.meta.props(this.recordable);
        },
        enumerable: false,
        configurable: true
    });
    RecordableView.prototype.init = function () {
        return __awaiter(this, void 0, Promise, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        this.section = this.routeService.routeSectionNumber();
                        return [4 /*yield*/, this.refreshRecordable(this.type)];
                    case 1:
                        _a.sent();
                        this.setDeadline();
                        return [4 /*yield*/, this.refreshLockState()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.refreshValidationErrors(this.type)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RecordableView.prototype, "basePath", {
        get: function () {
            var fragments = this.$route.path.split('/');
            return fragments[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "subRoutes", {
        get: function () {
            return this.routeService.recordRoutes("/" + this.basePath + "/");
        },
        enumerable: false,
        configurable: true
    });
    RecordableView.prototype.setDeadline = function () {
        this.deadline = this.recordable.record.deadline;
    };
    RecordableView.prototype.goToNextPage = function () {
        this.routeService.goToNext(this.subRoutes);
    };
    RecordableView.prototype.goToPreviousPage = function () {
        this.routeService.goToPrevious(this.subRoutes);
    };
    RecordableView.prototype.validateRecord = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validate(this.type)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RecordableView.prototype.manualValidateRecord = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.manualValidate(this.type)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RecordableView.prototype.sendRecord = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.send(this.type)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RecordableView.prototype.deleteRecord = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasProcuration) {
                            return [2 /*return*/, this.userCantSendOrDeleteNotificationMessage(false)];
                        }
                        return [4 /*yield*/, this.delete(this.type)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RecordableView.prototype, "hasLinkFactory", {
        get: function () {
            return !!this.instructionLinksFactory;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "links", {
        get: function () {
            return this.instructionLinksFactory(this.instructionLinks, this.languageCode, this.recordable);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "customLinks", {
        get: function () {
            if (this.hasLinkFactory)
                return this.links.links;
            else
                return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordableView.prototype, "recordIsDeletable", {
        get: function () {
            var recordTypeDeletable = this.$route.meta.deletable;
            return recordTypeDeletable;
        },
        enumerable: false,
        configurable: true
    });
    RecordableView.prototype.submit = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasProcuration) {
                            return [2 /*return*/, this.userCantSendOrDeleteNotificationMessage()];
                        }
                        if (this.sending) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.sendValidate(this.type, !this.isSinglePageForm)];
                    case 1:
                        _a.sent();
                        if (!(!this.hasValidationErrors && this.isRecordSendable)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.send(this.type)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: String, required: true }),
        __metadata("design:type", String)
    ], RecordableView.prototype, "recordableType", void 0);
    __decorate([
        Prop({ type: Function, required: true }),
        __metadata("design:type", Function)
    ], RecordableView.prototype, "titleKey", void 0);
    __decorate([
        Prop({ type: Function, required: false }),
        __metadata("design:type", Function)
    ], RecordableView.prototype, "specifierKey", void 0);
    __decorate([
        Prop({ type: Function, required: false, default: null }),
        __metadata("design:type", Function)
    ], RecordableView.prototype, "instructionLinksFactory", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], RecordableView.prototype, "multipleSections", void 0);
    __decorate([
        Watch("$route"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], RecordableView.prototype, "onRouteChanged", null);
    RecordableView = __decorate([
        Component({
            name: "RecordableView",
            components: {
                NavRow: NavRow,
                ValidationObserver: ValidationObserver,
                ValidationErrors: ValidationErrors,
                HeaderRow: HeaderRow,
                InstructionLink: InstructionLink,
                PrintPdf: PrintPdf,
                FormStatus: FormStatus
            }
        })
    ], RecordableView);
    return RecordableView;
}(TemplateBase));
export default RecordableView;
